import React from 'react';
import classnames from 'classnames/bind';
import { Drawer } from '@mantine/core';

import { WidgetType } from 'types/dashboard_widget';

import { useModal } from 'hooks/useModal';

import { AddWidgetDrawerTypeSelect } from './TypeSelect';
import { WidgetForm } from './Form';

import styles from './WidgetDrawer.module.scss';

const c = classnames.bind(styles);

type AddWidgetDrawerProps = {
  open?: boolean;
  dashboardId: string;
};

export function AddWidgetDrawer({
  open = false,
  dashboardId,
}: AddWidgetDrawerProps) {
  const { close } = useModal();

  return (
    <Drawer.Root
      opened={open}
      closeOnClickOutside={false}
      closeOnEscape={false}
      onClose={() => close()}
      position="right"
      classNames={{
        overlay: c('overlay'),
        inner: c('inner'),
        content: c('content'),
      }}
      padding={0}
    >
      <Drawer.Overlay />
      <Drawer.Content>
        <AddWidgetDrawerContent dashboardId={dashboardId} />
      </Drawer.Content>
    </Drawer.Root>
  );
}

function AddWidgetDrawerContent({ dashboardId }: AddWidgetDrawerProps) {
  const [type, setType] = React.useState<WidgetType>();

  if (!type) {
    return <AddWidgetDrawerTypeSelect onChange={setType} />;
  }

  return <WidgetForm type={type} dashboardId={dashboardId} />;
}
